import React from "react";
import { Icon } from "@blueprintjs/core";
import PropTypes from "prop-types";
import "./Notifications.css";

export function FailurePanel({
    title = "",
    children = <></>
}) {
    return (
        <div className="notification-panel failure-panel">
            <div className="spacer-bottom-large">
                <Icon
                    icon="ban-circle"
                    size={100}
                />
            </div>
            <h2>{title}</h2>
            {children}
        </div>
    );
}

FailurePanel.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node
};